import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../../Components/Common/BreadCrumb'
import moment from 'moment';
import { API_USERS_CRM, getDataFromUrl } from '../../api';
import { BACKEND_HOST } from '../../api';
import { postData } from '../../api';
import { SUBDOMAIN } from "../../assets/meta/meta";
import UserSelectBox from '../../Components/Common/UserSelectBox';

import toast, { Toaster } from 'react-hot-toast';
import { Button } from '@/Components/ui';
import CommonDatePicker from "@/Components/Common/CommonDatePicker";


const PushAppNotification = () => {
    const navigate = useNavigate();
    const [title, setTitle] = React.useState("");
    // const [image, setImage] = React.useState("");
    // const [link, setLink] = React.useState("");

    const [body, setBody] = React.useState("");
    const [notificationCode, setNotificationCode] = React.useState("");
    const [notificationCodeTypes, setNotificationCodeTypes] = React.useState([]);
    const [notificationVars, setNotificationVars] = React.useState([]);

    const [sendType, setSendType] = React.useState("now");
    const [messageType, setMessageType] = React.useState("normal"); // normal, ads
    const [date, setDate] = React.useState(moment().format("YYYY-MM-DD"));
    const [sendtime, setSendtime] = React.useState(moment().format("HH:mm"));

    const [target, setTarget] = React.useState("current_site");
    const [userList, setUserList] = React.useState([]);

    const [reservDate, setReservDate] = React.useState(moment().format("YYYY-MM-DD"));

    const [search, setSearch] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [selectedUsers, setSelectedUsers] = React.useState([]);

    const [sites, setSites] = React.useState([]);
    const [selectedSite, setSelectedSite] = React.useState(SUBDOMAIN);

    const [linkUrl, setLinkUrl] = React.useState("");

    const [isSending, setIsSending] = React.useState(false);

    const abortController = useRef(null);

    const [usersSummary, setUsersSummary] = React.useState(null);

    const [lastNotificationResult, setLastNotificationResult] = React.useState(null);

    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/accounts/message-service/get_users_summary`)
            .then((data) => {
                console.log(data);
                setUsersSummary(data);
            }).catch((e) => { console.log(e); })
    }, [])

    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort();
        }

        if (search) {
            abortController.current = new AbortController();
            getDataFromUrl(`${API_USERS_CRM}/?search=${search}`, abortController.current.signal)
                .then((data) => {
                    console.log(data);
                    setUserList(data.results);
                    // setPrevious(data.previous);
                    // setNext(data.next);
                    setCount(data.count);
                })
                .catch((e) => { console.log(e); })
        }
    }, [search])

    useEffect(() => {
        const _descript = notificationCodeTypes.filter((item) => item.code === notificationCode)[0]?.descript;
        // text = "hello #{name}. Good #{time_part}!"
        const _vars = _descript?.match(/#\{[a-zA-Z_]+\}/g)?.map((item) => item.replace(/#\{|\}/g, ""));
        setNotificationVars(_vars);
    }, [notificationCode, notificationCodeTypes])

    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/accounts/notificationTypes/`)
            .then((data) => {
                console.log(data);
                setNotificationCodeTypes(data);
            })
            .catch((e) => { console.log(e); })

        getDataFromUrl(`${BACKEND_HOST}/sites/camps/`)
            .then((data) => {
                // console.log(data);
                const _sites = data.filter((item) => !!item.subdomain);
                setSites(_sites);
            })
            .catch((e) => { console.log(e); })
    }, [])

    const handeleNotificationBody = () => {
        // text = "hello #{name}. Good #{time_part}!"
        const _varValues = [];
        const _elements = document.querySelectorAll("input[id^='notificationBody']");
        _elements.forEach((item) => {
            _varValues.push(item.value);
        })
        const _descript = notificationCodeTypes.filter((item) => item.code === notificationCode)[0]?.descript;

        const _vars = _descript?.match(/#\{[a-zA-Z_]+\}/g)?.map((item) => item.replace(/#\{|\}/g, ""));
        let _body = _descript;
        _vars?.forEach((item, index) => {
            _body = _body.replace(`#{${item}}`, _varValues[index]);
        })
        setBody(_body);
    }

    const resetForm = (clear_all = false) => {
        // setImage("");
        // setLink("");
        setSendType("now");
        setDate(moment().format("YYYY-MM-DD"));
        setSendtime(moment().format("HH:mm"));
        // setTarget("all");
        setSelectedUsers([]);
        // setSelectedSite("");
        setReservDate("");

        if (clear_all) {
            setNotificationCode("");
            setMessageType("normal");
            setTitle("");
            setBody("");
            setLinkUrl("");
        }
    }

    const sendNotification = () => {
        const _codeVarObj = {}
        if (notificationCode) {
            const _descript = notificationCodeTypes.filter((item) => item.code === notificationCode)[0]?.descript;
            // text = "hello #{name}. Good #{time_part}!"
            const _vars = _descript?.match(/#\{[a-zA-Z_]+\}/g)?.map((item) => item.replace(/#\{|\}/g, ""));
            const _varValues = []
            const _elements = document.querySelectorAll("input[id^='notificationBody']");
            _elements.forEach((item) => {
                _varValues.push(item.value);
            })
            _vars?.forEach((item, index) => {
                _codeVarObj[item] = _varValues[index];
            })
        }

        const _data = {
            title: title,
            // image: image,
            // link: link,
            body: body,
            notificationCode: notificationCode,
            codeObj: _codeVarObj,
            sendType: sendType,
            messageType: messageType,
            // sendtime: sendtime,
            datetime: `${date} ${sendtime}`, // YYYY-MM-DD HH:mm 
            target: target,
            users: selectedUsers,
            site: selectedSite,
            reserv_date: reservDate,
            data: `{"url": "${linkUrl}"}`,
            // targetCheck: true, // test mode
        }
        console.log(_data);

        setIsSending(true);
        postData(`/accounts/push-app-notification/`, _data)
            .then((data) => {
                console.log(data);
                setLastNotificationResult(data);
                if (data.result === "ok") {
                    toast.success("알림이 성공적으로 발송되었습니다.");
                    resetForm();
                } else {
                    toast.error(`알림 발송에 실패했습니다.`);
                }
            })
            .catch((e) => {
                console.log(e);
                toast.error(`알림 발송에 실패했습니다. ${e?.message}`);
            })
            .finally(() => {
                setIsSending(false);
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <BreadCrumb title="앱 알림 보내기" pageTitle="알림" />

                    <div className="flex flex-wrap -mx-3 g-4 mb-3">
                        <div className="col-sm-auto">
                            <div>
                                <h4 className="card-title mb-0 flex-grow-1">알림 보내기</h4>
                            </div>
                        </div>
                        <div className="col-sm-3 ms-auto">
                            {!isSending ? <div className="d-flex justify-content-sm-end gap-2">
                                <Button  onClick={sendNotification} id="create-btn" color="success" className="add-btn me-1">
                                    보내기
                                </Button>
                                <Button  onClick={() => { navigate(`/dashboard-crm`) }} id="cancel-btn" color="danger" className="add-btn me-1">
                                    취소
                                </Button>
                            </div> : <div className="d-flex justify-content-sm-end gap-2">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>}
                        </div>
                    </div>

                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full xxl:w-6/12 px-3">
                            <div className="card">
                                <div className="card-body">
                                    <div className="live-preview">
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <div className="mb-3">
                                                        <h5 className="card-title">알림 작성</h5>
                                                    </div>
                                                    <Button  onClick={() => resetForm(true)} color="secondary" className="mb-3">폼 초기화</Button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                                    <div className="">
                                                        <h5 className="card-title">서비스 정보</h5>
                                                    </div>
                                                    <div className='d-flex gap-3' style={{
                                                        backgroundColor: "#ffdddd", padding: "8px 10px"
                                                    }}>
                                                        <div className='d-flex flex-column' style={{
                                                        }}>
                                                            <span style={{ marginLeft: "10px" }}>지점 고객: {usersSummary?.total || 0}명</span>
                                                            <span style={{ marginLeft: "10px" }}>앱 알림 가능: {usersSummary?.app_notification_ready || 0}명</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className="mb-3 d-flex justify-content-between">
                                                    <label htmlFor="notificationMessageType" className="form-label">타입 </label>
                                                    <div className="btn-group" role="group" aria-label="알림 타입">
                                                        <button className={`btn ${messageType === "normal" ? "btn-primary" : "btn-light"}`} style={{ width: "100px" }}
                                                            onClick={() => setMessageType("normal")}>일반 공지</button>
                                                        <button className={`btn ${messageType === "ads" ? "btn-primary" : "btn-light"}`} style={{ width: "100px" }}
                                                            onClick={() => setMessageType("ads")}>광고</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="notificationTitle" className="form-label">제목</label>
                                                    <input type="text" className="form-control" id="notificationTitle" placeholder="제목을 입력하세요" value={title} onChange={(e) => setTitle(e.target.value)} />

                                                </div>
                                            </div>

                                        </div>

                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3 d-flex justify-content-between">
                                                    <label htmlFor="notificationSendType" className="form-label">발송 일시</label>
                                                    <div className="btn-group" role="group" aria-label="발송 타입">
                                                        <button className={`btn ${sendType === "now" ? "btn-primary" : "btn-light"}`} style={{ width: "100px" }}
                                                            onClick={() => setSendType("now")}>즉시</button>
                                                        <button className={`btn ${sendType === "schedule" ? "btn-primary" : "btn-light"}`} style={{ width: "100px" }}
                                                            onClick={() => setSendType("schedule")}>예약</button>
                                                    </div>

                                                </div>
                                            </div>
                                            {sendType === "schedule" && <>
                                                <div className="w-full md:w-6/12 px-3">
                                                    <div className="mb-3">
                                                        {/* <label htmlFor="notificationDate" className="form-label">날짜</label> */}
                                                        <CommonDatePicker className="form-control" id="notificationDate" placeholder="날짜를 입력하세요" value={date} clearable onChangeValue={setDate} />
                                                    </div>
                                                    <div className="mb-3">
                                                        {/* <label htmlFor="notificationSendtime" className="form-label">시간</label> */}
                                                        <input type="time" className="form-control" id="notificationSendtime" placeholder="시간을 입력하세요" value={sendtime} onChange={(e) => setSendtime(e.target.value)} />
                                                    </div>
                                                </div>
                                            </>}
                                        </div>

                                        {/* <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="notificationCode" className="form-label">알림 코드 (알림 내용 양식)</label>
                                                    <input type='select' className="form-control" id="notificationCode" placeholder="알림 코드를 입력하세요" value={notificationCode} onChange={(e) => setNotificationCode(e.target.value)}>
                                                        <option value="">직접 입력</option>
                                                        {notificationCodeTypes.map((item, index) => (
                                                            <option key={index} value={item.code}>{item.code}</option>
                                                        ))}
                                                    </input>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                {notificationVars ? <div className="mb-3">
                                                    {notificationVars.map((item, index) => (
                                                        <div key={index}>
                                                            <label htmlFor={`notificationBody${index}`} className="form-label">{item}</label>
                                                            <input type="text" className="form-control" id={`notificationBody${index}`} placeholder={`${item}을 입력하세요`}
                                                                onChange={(e) => handeleNotificationBody()} />
                                                        </div>
                                                    ))}

                                                    <div className="mb-3" style={{ color: "GrayText" }}>
                                                        * username, phone_num 등의 필드는 알림을 받는 사용자의 정보로 자동 대체 됩니다.
                                                    </div>
                                                </div> : null}
                                                <div className="mb-3">
                                                    <label htmlFor="notificationBody" className="form-label">내용 *</label>
                                                    <textarea className="form-control" id="notificationBody" placeholder="내용을 입력하세요"
                                                        value={body} onChange={(e) => setBody(e.target.value)}
                                                        rows={3}
                                                        disabled={notificationCode} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-full px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="linkUrl" className="form-label">링크 URL <span style={{ color: "GrayText" }}>(앱 알림 버튼에 포함)</span></label>
                                                    <input type="text" className="form-control" id="linkUrl" placeholder="URL을 입력하세요" value={linkUrl} onChange={(e) => setLinkUrl(e.target.value)} />
                                                    <span style={{ color: "GrayText" }}>** url 예시: amazingcamp://mypage , https://www.amazingticket.site</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full xxl:w-6/12 px-3">
                            <div className="card">
                                <div className="card-body">
                                    <div>

                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-4/12 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="notificationTarget" className="form-label">대상</label>
                                                    <select className="form-control" id="notificationTarget" value={target} onChange={(e) => setTarget(e.target.value)}>
                                                        {/* <option value="all">전체</option> */}
                                                        {/* <option value="site">지점 선택</option> */}
                                                        <option value="current_site">지점 고객 전체</option>
                                                        <option value="user">회원 직접 선택</option>
                                                        {/* <option value="admin">관리자 전체</option> */}
                                                        <option value="reserv_user">예약일 해당고객</option>
                                                        <option value="reserv_checkedin_user">예약일 이용중인 고객(체크인)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {target === "user" && <>
                                            <div className="flex flex-wrap -mx-3">
                                                <div className="w-full md:w-full px-3">
                                                    <UserSelectBox
                                                        title='회원 선택'
                                                        userList={userList}
                                                        setUserList={setUserList}
                                                        selectedUsers={selectedUsers}
                                                        setSelectedUsers={setSelectedUsers}
                                                        search={search}
                                                        setSearch={setSearch}
                                                        count={count}
                                                        setCount={setCount}
                                                    />
                                                </div>
                                            </div>
                                        </>}
                                        {(target === "current_site" || target === "site" || target === "reserv_user" || target === "reserv_checkedin_user") && <>
                                            <div className="flex flex-wrap -mx-3">
                                                <div className="w-full md:w-4/12 px-3">
                                                    <div className="mb-3">
                                                        <span>지점: {SUBDOMAIN}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}

                                        {(target === "site" || target === "reserv_user" || target === "reserv_checkedin_user") && <>
                                            <div className="flex flex-wrap -mx-3">
                                                {/* <div className="w-full md:w-4/12 px-3">
                                                    <div className="mb-3">
                                                        <div style={{ maxHeight: 300, overflowY: "auto" }}>
                                                            <label htmlFor="notificationSite" className="form-label">지점</label>
                                                            <select className="form-control" id="notificationSite" value={selectedSite} onChange={(e) => setSelectedSite(e.currentTarget.value)}>
                                                                <option value="">전체 지점</option>
                                                                {sites.map((site, index) => (
                                                                    <option key={index} value={site.subdomain}>{site.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {(target === "reserv_user" || target === "reserv_checkedin_user") && <>
                                                    <div className="w-full md:w-4/12 px-3">
                                                        <div className="mb-3">
                                                            <div style={{ maxHeight: 300, overflowY: "auto" }}>
                                                                <label htmlFor="notificationReservUser" className="form-label">예약일</label>
                                                                <CommonDatePicker className="form-control" id="notificationReservUser" placeholder="날짜를 입력하세요" value={reservDate} clearable onChangeValue={setReservDate} />
                                                                {/* <span>{reservDate}</span> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}
                                            </div>
                                        </>}


                                    </div>
                                </div>
                            </div>
                        </div>


                        {lastNotificationResult ? <div className="w-full xxl:w-6/12 px-3">
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-4/12 px-3">
                                                <div className="mb-3">
                                                    <h5 className="card-title">마지막 발송 결과</h5>
                                                    <div className='d-flex flex-column'>
                                                        <span>메세지: {lastNotificationResult.result}</span>
                                                        <span>총 고객: {lastNotificationResult.target_users}명</span>
                                                        <span>앱 알림: {lastNotificationResult.token_len}명</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : null}

                    </div>

                    <Toaster position="top-center" />

                </div>
            </div>
        </React.Fragment>
    )
}

export default PushAppNotification
